export default [
  {value: 30, label: '30 Días'},
  {value: 90, label: '90 Días'},
  {value: 180, label: '180 Días'},
  {value: 365, label: '1 Año'},
  {value: -1, label: 'Sin expiración'}
]
